const validate = (values, docType) => {

  const errors = {};

  const validateRazonNumero = (values) => {
    if (!values?.InformacionReferencia?.Razon) {
      errors.InformacionReferencia = {
        ...errors.InformacionReferencia,
        Razon: 'Debe ingresar la razón',
      };
    }
    if (!values?.InformacionReferencia?.Numero) {
      errors.InformacionReferencia = {
        ...errors.InformacionReferencia,
        Numero: 'Debe ingresar el número de documento',
      };
    }
  }

  if (!values?.Receptor?.Identificacion?.Numero) {
    errors.Receptor = {
      ...errors.Receptor,
      Identificacion: { Numero: 'Debe ingresar la cédula' }
    };
  }
  if (values?.Receptor?.Identificacion?.Tipo === "01" && values.Receptor?.Identificacion?.Numero?.length < 9) {
    errors.Receptor = {
      ...errors.Receptor,
      Identificacion: { Numero: 'Cédula física invalida' },
    };
  }

  if (values?.Receptor?.Identificacion?.Tipo === "02" && values.Receptor?.Identificacion?.Numero?.length < 10) {
    errors.Receptor = {
      ...errors.Receptor,
      Identificacion: { Numero: 'Cédula jurídica invalida' },
    };
  }

  if (values?.Receptor?.Identificacion?.Tipo === "03" && values.Receptor?.Identificacion?.Numero?.length > 12) {
    errors.Receptor = {
      ...errors.Receptor,
      Identificacion: { Numero: 'Cédula dimex invalida' },
    };
  }

  if (!values?.Receptor?.Nombre) {
    errors.Receptor = {
      ...errors.Receptor,
      Nombre: 'Debe ingresar el nombre',
    };
  }

  if (!values?.Receptor?.CorreoElectronico) {
    errors.Receptor = {
      ...errors.Receptor,
      CorreoElectronico: 'Debe ingresar email',
    };
  }

  if (docType === '02'|| docType ==='03') {

    validateRazonNumero(values);

    if (!values?.InformacionReferencia?.FechaEmision) {
      errors.InformacionReferencia = {
        ...errors.InformacionReferencia,
        FechaEmision: 'Debe ingresar la fecha de emisión',
      };
    }
  
    if (!values?.InformacionReferencia?.TipoDoc) {
      errors.InformacionReferencia = {
        ...errors.InformacionReferencia,
        TipoDoc: 'Debe ingresar el tipo de documento',
      };
    }
  
    if (!values?.InformacionReferencia?.Codigo) {
      errors.InformacionReferencia = {
        ...errors.InformacionReferencia,
        Codigo: 'Debe ingresar el código del documento',
      };
    }
  } else {

    if (values?.InformacionReferencia?.Razon || values?.InformacionReferencia?.Numero) {
      validateRazonNumero(values);
    }
  }
  if (!values?.DetalleServicio?.LineaDetalle?.length) {
    errors.LineaDetalle = {
      ...errors.LineaDetalle,
      Message: 'Debe ingresar al menos un producto a la lista'
    };
  }
  if(values.CodigoActividad?.length <= 5){
    errors.CodigoActividad = {
      ...errors,
      Message: 'La Actividad ecónomica no es valida'
    };
  }
  
  return errors;
};

export default validate;